import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { ViewProvider } from '../../providers/view/view';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { DadosProvider } from '../../providers/dados/dados';

@Component({
  selector: 'page-registro',
  templateUrl: 'registro.html',
})
export class RegistroPage {

  cliente = {nome:"", email:"", telefone:"", senha:"", confirmacaosenha:"", recebernotificacao:true};

  constructor(public navCtrl: NavController, private view:ViewProvider, private server:SemovelProvider, private dadosP:DadosProvider) {
  }

  ionViewDidLoad() {
  }

  validar(){
    const erros:Array<string> = [];
    const c = this.cliente;

    if(!c.nome || !c.nome.length || c.nome.length == 0  ){
      erros.push("O <b>nome</b> é obrigatório.");
    }
    
    if(!c.email || !c.email.length || c.email.length == 0  ){
      erros.push("O <b>e-mail</b> é obrigatório.");
    }

    //Removido pela solicitação da Apple.
    // if(!c.data_nascimento || !c.data_nascimento.length || c.data_nascimento.length == 0  ){
    //   erros.push("A <b>data de nascimento</b> é obrigatória.");
    // }

    if(!c.telefone || !c.telefone || c.telefone.length == 0  ){
      erros.push("O <b>telefone</b> é obrigatório.");
    }
    
    if(!c.senha || !c.senha.length || c.senha.length == 0  ){
      erros.push("A <b>senha</b> é obrigatória.");
    }

    if(!c.confirmacaosenha || !c.confirmacaosenha.length || c.confirmacaosenha.length == 0  ){
      erros.push("A <b>confirmação de senha</b> é obrigatória.");
    } else if(c.senha && c.confirmacaosenha !== c.senha ) {
      erros.push("A <b>senha</b> e a <b>confirmação de senha</b> são diferentes.");
    }

    if(erros.length > 0){
      let msg = "";
      for(var i = 0; i < erros.length; i++){
        msg += erros[i]+"<br>";
      }
      this.view.showMessage(msg);
      return false;
    }

    return true;
  }

  registrar(){
    if(!this.validar()){
      return;
    }
    
    const dados:any = Object.assign({},this.cliente);
    dados.token = this.dadosP.firebaseToken;

    this.server.postData( {method:"cliente/registrar"}, dados)
    .subscribe(
      (sucesso) => {
        this.view.showMessage(sucesso.mensagem, ()=>{
          this.fazer_login(this.cliente.email);
        });
      },
      (erro) => {
        this.view.showMessage(erro.message);
      }
    );
  }

  move_focus(componente){
    componente.setFocus();
  }

  fazer_login(email=null){
    this.navCtrl.setRoot(LoginPage,{email:email});
  }
}



// WEBPACK FOOTER //
// ./src/pages/registro/registro.ts